import { render, staticRenderFns } from "./WorkItemList.vue?vue&type=template&id=0bb82fe6&scoped=true&"
import script from "./WorkItemList.vue?vue&type=script&lang=js&"
export * from "./WorkItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb82fe6",
  null
  
)

export default component.exports